<template>
  <div class="fest4l-gate">
    <UICardGridSkeleton
      :count="2"
      with-media
      label="Переходим в личный кабинет..."
    />
  </div>
</template>

<script setup lang="ts">
import { resolveOwnerCabinetPath } from '~/utils/campaignRedirects';

useHead({
  title: 'Vetsy',
  meta: [{ name: 'robots', content: 'noindex, nofollow' }],
});

const authStore = useAuthStore();

onMounted(async () => {
  // Плагин updateToken уже вызвал restoreSession; повтор идемпотентен.
  authStore.restoreSession();

  if (authStore.isAuth) {
    await navigateTo(resolveOwnerCabinetPath(authStore.userRole), { replace: true });
    return;
  }

  await navigateTo({ path: '/', query: { auth: 'client' } }, { replace: true });
});
</script>

<style scoped lang="scss">
.fest4l-gate {
  width: 100%;
  max-width: 720px;
  margin: 32px auto;
  padding: 0 16px;
  box-sizing: border-box;
}
</style>
